import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

import '../../../css/components/batches/DetailsModal.css';

const DetailsModal = ({
    visible,
    large,
    onActionPress,
    onClose,
    title = 'Default title',
    img,
    content = 'Default content',
    leftButton,
    rightButton,
    children,
    styles,
}) => {
    const disableEnterKey = useCallback(e => {
        if (
            e.keyIdentifier === 'U+000A' ||
            e.keyIdentifier === 'Enter' ||
            e.keyCode === 13
        ) {
            e.preventDefault();
            document.activeElement.blur();
        }
    }, []);

    useEffect(() => {
        if (visible) {
            window.addEventListener('keydown', disableEnterKey, true);
        } else {
            window.removeEventListener('keydown', disableEnterKey, true);
        }
    }, [visible, disableEnterKey]);

    return (
        <div
            className={`c-modal ${large ? 'c-modal--large' : ''}`}
            aria-hidden={!visible}
        >
            <div className="c-modal__overlay  js-modal-close" tabIndex="-1" />
            <div
                className="c-modal__wrapper"
                role="dialog"
                aria-labelledby="details-modal"
            >
                {children ? (
                    children
                ) : (
                    <>
                        <header className="c-modal__header u-p-small@s">
                            <div className="c-modal__title__wrapper">
                                {img && img}
                                <h1
                                    className="c-modal__title"
                                    id="details-modal-id"
                                >
                                    {title}
                                </h1>
                            </div>
                            {onClose && (
                                <button
                                    className="c-modal__close-btn  js-modal-close"
                                    type="button"
                                    aria-label="Close modal icon"
                                    onClick={onClose}
                                />
                            )}
                        </header>
                        <div
                            className={`c-modal__content ${
                                large
                                    ? 'u-ph-xlarge u-ph-none@s u-mh-small@s'
                                    : '' //workaround for bronson styling specificity
                            }`}
                            role="document"
                        >
                            {content}
                        </div>
                        <div
                            className={`c-modal__footer ${
                                large ? 'u-pb-large' : ''
                            }`}
                        >
                            <div className="c-modal__actions o-button-container">
                                {leftButton && (
                                    <div className="c-modal__actions__item">
                                        <button
                                            className="c-btn  c-btn--secondary  js-modal-close  js-modal-autofocus"
                                            aria-label="Close modal"
                                            onClick={onClose}
                                        >
                                            <span className="c-btn__text">
                                                {leftButton}
                                            </span>
                                        </button>
                                    </div>
                                )}
                                {rightButton && (
                                    <div className="c-modal__actions__item">
                                        <button
                                            className="c-btn  js-modal-close  js-modal-autofocus"
                                            aria-label="Close modal and confirm"
                                            onClick={onActionPress}
                                        >
                                            <span className="c-btn__text">
                                                {rightButton}
                                            </span>
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

DetailsModal.propTypes = {
    visible: PropTypes.any,
    large: PropTypes.bool,
    onActionPress: PropTypes.func,
    onClose: PropTypes.func,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    img: PropTypes.any,
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    leftButton: PropTypes.string,
    rightButton: PropTypes.string,
    children: PropTypes.any,
};

export default DetailsModal;
